import {Article} from '@apuestes/types'
import {initialArticleState} from '../../../../_metronic/helpers'
import {createSlice} from '@reduxjs/toolkit'
import {apuestesAPI} from '../../services/apuestesAPI'

const articleSlice = createSlice({
  name: 'article',
  initialState: {
    meta: {fetch: false, id: -1},
    value: initialArticleState,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addMatcher(apuestesAPI.endpoints.getModelById.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.model === 'articles/bo') {
          state.value = action.payload as unknown as Article
        }
      })
      .addMatcher(apuestesAPI.endpoints.updateModel.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.model === 'articles') {
          state.value = action.payload as unknown as Article
        }
      })
  },
})

export default articleSlice.reducer
